import Fade from "react-reveal/Fade";

export default function SectionSeven() {
  return (
    <div className="flex flex-col text-center mb-24">
      <Fade bottom>
        <h1 className="md:text-4xl text-3xl font-black uppercase">
          KENAPA MEMILIH CREATIFA STUDIO?
        </h1>

        <p className="md:w-8/12 mx-auto font-medium text-2xl mt-5">
          Kami telah berpengalaman dalam bidang desain grafis sejak 2020. Telah
          menangani ribuan client dari berbagai bidang usaha. Harga yang kami
          tawarkan sangat bersahabat.
          <br />
          <br />
          Kami mampu memberikan tripple garansi:
        </p>

        <div className="grid md:grid-cols-3 grid-cols-1 md:mt-24">
          <div>
            <img className="w-full" src="/img/loloshaki.jpg" alt="LOLOS HAKI" />
          </div>
          <div>
            <img
              className="w-full md:-mt-20"
              src="/img/kepuasan.jpg"
              alt="100% KEPUASAN"
            />
          </div>
          <div>
            <img
              className="w-full"
              src="/img/uangkembali.jpg"
              alt="UANG KEMBALI"
            />
          </div>
        </div>
      </Fade>
    </div>
  );
}
